import { TimelineGroupStyle } from '../styles/timelineGroupStyle';
export const defaultRowHeight = 24;
const margin = 4;
export const defaultGroupStyle = {
  height: 'auto',
  marginTop: margin,
  /**
   * Default group fill color.
   */
  fillColor: '#094771',
} as TimelineGroupStyle;
